document.addEventListener("submit", async (e) => {
	if (!e.target.matches(".contact-form")) {
		return;
	}

	e.preventDefault();

	const formData = new FormData(e.target);

	const response = await fetch(
		"http://localhost:8080/odeondentalBlock/wp-json/custom/v1/contact",
		{
			method: "POST",
			body: formData,
		},
	);

	const result = await response.json();

	alert(result.message);
});
